export enum OverviewType {
    None,
    Own,
    Shared,
    Archived
}



// WEBPACK FOOTER //
// ./src/app/modules/domain/enums/overviewType.ts